import { ApolloError, useQuery } from '@apollo/client';
import OvertimeEditDetailsQuery from './graphql/OvertimeEditDetails.query';
import { OvertimeEditDetails } from './graphql/__generated__/OvertimeEditDetails.query';
import useProjectEmployees from '../../hooks/useProjectEmployees/useProjectEmployees';
import useProfessions from '../../hooks/useProfessions';
import { Employee } from '../../hooks/useProjectEmployees/graphql/__generated__/Employee.fragment';

interface UseOvertimeEditDetailOptions {
  overtimeId: string;
  projectId: string;
  pdfRedesignEnabled: boolean;
}

interface UseOvertimeEditDetailResponse {
  overtime?: OvertimeEditDetails['overtime'];
  employees: Employee[];
  professions: string[];
  employeeAutomaticRoleSelection: boolean;
  loading: boolean;
  error?: ApolloError;
}

const OVERTIME_IMAGE_THUMBNAIL_WIDTH = 56 * 2;
const OVERTIME_IMAGE_THUMBNAIL_HEIGHT = 40 * 2;

export default function useOvertimeEditDetail({
  overtimeId,
  projectId,
  pdfRedesignEnabled,
}: UseOvertimeEditDetailOptions): UseOvertimeEditDetailResponse {
  const { data, loading, error } = useQuery(OvertimeEditDetailsQuery, {
    variables: {
      overtimeId,
      thumbnailWidth: OVERTIME_IMAGE_THUMBNAIL_WIDTH,
      thumbnailHeight: OVERTIME_IMAGE_THUMBNAIL_HEIGHT,
      pdfRedesignEnabled,
    },
    fetchPolicy: 'network-only',
  });

  const overtime = data?.overtime;
  const employeeAutomaticRoleSelection =
    data?.viewer?.overtimePreferences.employeeAutomaticRoleSelection ?? true;
  const { employees } = useProjectEmployees(projectId);
  const { professions } = useProfessions();

  return {
    overtime,
    professions,
    employees,
    employeeAutomaticRoleSelection,
    loading,
    error,
  };
}
